import React from "react";

import Slider from "react-slick";

const Testimonials = () => {
  const reviews = [
    {
      name: "John Doe",
      position: "CTO at a Mid-Sized Manufacturing Firm",
      src: "images/testimonial/client-sm-1.jpg",
      desc: "Working with Rafal was a game-changer for our automation strategy. His ability to quickly grasp our complex business processes and translate them into a practical, high-ROI AI solution was remarkable. He delivered a robust system that exceeded our expectations and has already shown a significant impact on our operational efficiency.",
    },
    {
      name: "Jane Smith",
      position: "VP of Operations at a Logistics Company",
      src: "images/testimonial/client-sm-2.jpg",
      desc: "Rafal is more than just a technologist; he is a true strategic partner. He took the time to understand our long-term goals and helped us build a scalable AI roadmap. His deep experience and pragmatic approach gave us the confidence we needed to move forward with our digital transformation.",
    },
    {
      name: "Peter Jones",
      position: "Head of Customer Service at an E-commerce Platform",
      src: "images/testimonial/client-sm-3.jpg",
      desc: "The AI-powered chatbot solution that Rafal implemented has transformed our customer service. We\'ve seen a 70% reduction in response times and a significant increase in customer satisfaction. His project management skills and clear communication made the entire process seamless and efficient.",
    },
  ];

  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={
        "slick-prev slick-arrow" + (currentSlide === 0 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
      type="button"
    >
      <i className="fa fa-chevron-left"></i>
    </button>
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={
        "slick-next slick-arrow" +
        (currentSlide === slideCount - 1 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
      type="button"
    >
      <i className="fa fa-chevron-right"></i>
    </button>
  );

  var settings = {
    dots: true,
    arrows: true,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4500,
  };

  return (
    <section id="testimonial" className="section bg-secondary">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeIn">
          <span className="bg-primary text-dark px-2">Testimonials</span>
        </p>
        <h2 className="text-10 fw-600 text-white text-center mb-5 wow fadeIn">
          What Some of my Clients Say
        </h2>
        {/* Heading end*/}
        <div className="row">
          <div className="col-lg-9 mx-auto wow fadeInUp">
            <Slider {...settings}>
              {reviews.length > 0 &&
                reviews.map((review, index) => (
                  <div className="item text-center px-5" key={index}>
                    {" "}
                    <span className="text-9 text-primary">
                      <i className="fa fa-quote-start" />
                    </span>
                    <p className="text-5 text-white">{review.desc}</p>
                    <img
                      className="img-fluid d-inline-block w-auto rounded-circle shadow"
                      src={review.src}
                      alt={review.name}
                    />{" "}
                    <strong className="d-block text-3 fw-600 text-white">
                      {review.name}
                    </strong>{" "}
                    <span className="text-light">{review.position}</span>{" "}
                  </div>
                ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
